import { Traduccion, TraduccionFiltro } from "@/model/Traduccion";
import store from "@/store";
import { Utilidades } from "./Utilidades";
import { TraduccionService } from "@/services/TraduccionService";
import { Tarea, TareaPaginaFiltro } from "@/model/Tarea";
import { TareaService } from "@/services/TareaService";

export class TraduccionesTareas {
    public static traduccion({ texto, tag, replace }: { texto: string, tag: string, replace?: Array<[string, string]> }): string {
        try {

            let result = "";
            let posfix = "";

            if (Utilidades.isNullOrUndefinedOrEmpty(tag) && !Utilidades.isNullOrUndefinedOrEmpty(texto)) {
                tag = this.generar_tag_traduccion(texto);
            }

            if (tag == null || tag == undefined) {
                tag = ''
            }

            if (texto == null || texto == undefined) {
                texto = ''
            }

            if (!tag.trim().startsWith("{{"))
                tag = "{{" + tag;

            if (!tag.trim().endsWith("}}"))
                tag = tag + "}}";

            switch (true) {
                case !tag.trim().startsWith("{{"):
                    tag = "{{" + tag;
                case !tag.trim().endsWith("}}"):
                    tag = tag + "}}";
                case texto.trim().endsWith(": *"):
                    posfix = ": *";
                    break;
                case texto.trim().endsWith(":*"):
                    posfix = ":*";
                    break;
                case texto.trim().endsWith(":"):
                    posfix = ":";
                    break;
                case texto.trim().endsWith("**"), texto.trim().endsWith(":**"), texto.trim().endsWith(": **"):
                    posfix = ": **";
                    break;
                default:
                    break;
            }

            texto = texto.replaceAll("*", "").replaceAll(":", "").trim();
            result = this.traduccir({ texto: texto, tag: tag });

            if (replace) {
                replace.forEach(x => {
                    result = result.replace(x[0], x[1]);
                });
            }

            return result + posfix;
        }
        catch {
            return texto;
        }
    }

    public static async updateTraduccion(traducciones: Array<Traduccion>, pagina) {
        try {
            var filtro = new Object() as TraduccionFiltro;
            filtro.pagina = pagina;

            // filtro.traduciones = traducciones.filter((x) => x.tag_utilizada === true && !Utilidades.isNullOrUndefinedOrEmpty(x.texto_original));
            filtro.traduciones = traducciones.filter((x) => x.tag_utilizada === true);

            if (Utilidades.isNullOrUndefinedOrEmpty(filtro.pagina) || filtro?.traduciones?.length == 0) {
                return;
            }

            await TraduccionService.actualizarTraducciones(filtro)
                .then()
                .catch((err) => {
                    Utilidades.Message({ message: err.response.data, error: true });
                });
        } catch { }
    }

    private static traduccir({ texto, tag }: { texto: string, tag: string }): string {
        try {

            var val = new Object() as Traduccion;

            if (!store.state.traducciones) {
                store.commit("setTraducciones", new Array<Object>() as Array<Traduccion>)
            }

            val = store.state.traducciones?.find(
                (x) =>
                    x.tag_texto?.trim()?.toUpperCase() == tag?.trim()?.toUpperCase()
            );

            var aux = new Object() as Traduccion;
            aux.texto_traducido = (val?.texto_traducido ? val?.texto_traducido : texto);
            aux.tag_texto = tag;
            aux.tag_utilizada = true;

            if (Utilidades.isNullOrUndefinedOrEmpty(texto) && !Utilidades.isNullOrUndefinedOrEmpty(tag) && val) {
                aux.texto_original = val?.texto_original;
            } else {
                aux.texto_original = (val?.texto_original ? val?.texto_original : texto);
            }

            if (!val) {
                store.commit('insertTraduccion', aux);
            }
            else {

                let index = store.state.traducciones.indexOf(val);
                var trad = Utilidades.clonarObjeto(store.state.traducciones[index]);
                trad.tag_utilizada = true;

                store.commit('updateTraduccion', { index: index, datos: trad })
            }

            return aux.texto_traducido ? aux.texto_traducido : aux.texto_original;
        }
        catch (ex) {
            return "";
        }
    }

    private static generar_tag_traduccion(texto: string): string {
        if (Utilidades.isNullOrUndefinedOrEmpty(texto))
            return texto;
        else {
            texto = texto.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); //Remove acentos
            texto = texto.toUpperCase().trim();
            texto = texto.replaceAll(" ", "_");
            texto = texto.replaceAll("*", "");
            texto = texto.replaceAll(":", "");
            texto = texto.replaceAll(".", "");
            texto = texto.endsWith("_") ? texto.substring(0, texto.length - 1) : texto;
            return texto.trim();
        }
    }

    public static tiene_tarea(tarea: string) {
        var obj = store.state.tareas.find((x) => x.cod_tarea == tarea);

        if (obj && !obj?.nueva) {
            let index = store.state.tareas.indexOf(obj);
            var tareaAux = store.state.tareas[index];
            tareaAux.tarea_utilizada = true;
            tareaAux.tiene_tarea = true;
            tareaAux.nueva = false;
            store.commit('updateTarea', { index: index, datos: tareaAux })
        } else {

            let aux = new Object() as Tarea;
            aux.cod_tarea = tarea;
            aux.tarea_utilizada = true;
            aux.tiene_tarea = false;
            aux.nueva = true;
            store.commit('insertTarea', aux)
        }

        obj = store.state.tareas.find(
            (x) => x.cod_tarea == tarea && x.tiene_tarea
        );

        return obj ? true : false;
    }

    public static async updateTareasPagina(tareas: Array<Tarea>, pagina) {
        try {
            var filtro = new Object() as TareaPaginaFiltro;
            filtro.pagina = pagina
            filtro.tareas = new Array<string>();

            tareas.forEach((x) => {
                if (x.tarea_utilizada == true) {
                    filtro.tareas.push(x.cod_tarea);
                }
            });

            if (filtro.tareas.length > 0) {
                await TareaService.actualizarTareasPagina(filtro)
                    .then()
                    .catch((err) => {
                        Utilidades.Message({ message: err.response.data, error: true });
                    });
            }

        } catch { }
    }
}